import React from 'react'
import Botao from '../../../Mantine/Botao/index.jsx'
import Group from '../../../Mantine/Group/index.jsx'
import Modal from '../../../Mantine/Modal/index.jsx'
import * as S from './styles.js'

export default function Alerta({ onClick, opened }) {
  return (
    <div>
      <Modal
        titulo="Atenção!"
        width={'450px'}
        type="alerta"
        opened={opened}
        positionTitle="center"
      >
        <S.ModalAlert>
          <p className="modal-alert">
            Este usuário foi bloqueado por questões de segurança. Para mais
            informações, entre em contato com o suporte.
          </p>
          <Group position="center">
            <Botao label="Fechar" variant="outline" onClick={onClick} />
          </Group>
        </S.ModalAlert>
      </Modal>
    </div>
  )
}
